import MainTipos from './MainTipos';

const ModalErrorAction = (estado) => {
    return async dispatch => {
        dispatch({ type: MainTipos.data.MOSTRAR_MODAL_ERROR_GENERICO, payload: { showModal: estado } });
    };
};

export default ModalErrorAction;